module.exports = __webpack_public_path__ + "img/mob_home_02.4c628b1f.png";